import React from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom';
import { NavLink, Route } from 'react-router-dom';
import { Redirect } from 'react-router';
import LoadingSpinner from '../loadingspinner/LoadingSpinner';
import { Context } from "../configcontext/ConfigContext";
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AccountMapping.css';

class AccountMapping extends React.Component {

	static contextType = Context;

	constructor(props) {
		super(props);
		this.state = {
			jwt: "",
			loading: true,
			authorized: false,
			territoryDropdown: false,
			territoryUpdate: false,
			waterDropdown: false,
			waterUpdate: false,
			electricDropdown: false,
			electricUpdate: false,
			gasDropdown: false,
			gasUpdate: false,
			sanitaryDropdown: false,
			sanitaryUpdate: false,
			stormDropdown: false,
			stormUpdate: false,
			fiberDropdown: false,
			fiberUpdate: false,
			telecomDropdown: false,
			telecomUpdate: false,
			steamDropdown: false,
			steamUpdate: false,
			featureServices: [],
			esriFeatureServices: [],
			//territory
			territoryFeatureService: "",
			territoryFeatureLayer: "",
			territoryFeatureLayerURL: "",
			territoryFeatureLayers: [],
			territoryShapefile: false,
			territoryField1: "",
			territoryFields: [],
			//control point
			controlpointFeatureService: "",
			controlpointFeatureLayer: "",
			controlpointFeatureLayerURL: "",
			controlpointFeatureLayers: [],
			controlpointShapefile: false,
			controlpointFields: [],
			controlpointAttributes: [],
			// water main
			watermainFeatureService: "",
			watermainFeatureLayer: "",
			watermainFeatureLayerURL: "",
			watermainFeatureLayers: [],
			watermainShapefile: false,
			watermainField1: "",
			watermainField2: "",
			watermainField3: "",
			watermainFields: [],
			watermainAttributes: [],
			// water service
			waterserviceFeatureService: "",
			waterserviceFeatureLayer: "",
			waterserviceFeatureLayerURL: "",
			waterserviceFeatureLayers: [],
			waterserviceShapefile: false,
			waterserviceField1: "",
			waterserviceField2: "",
			waterserviceField3: "",
			waterserviceFields: [],
			waterserviceAttributes: [],
			// water main valve
			watermainvalveFeatureService: "",
			watermainvalveFeatureLayer: "",
			watermainvalveFeatureLayerURL: "",
			watermainvalveFeatureLayers: [],
			watermainvalveShapefile: false,
			watermainvalveField1: "",
			watermainvalveFields: [],
			watermainvalveAttributes: [],
			// water service valve
			waterservicevalveFeatureService: "",
			waterservicevalveFeatureLayer: "",
			waterservicevalveFeatureLayerURL: "",
			waterservicevalveFeatureLayers: [],
			waterservicevalveShapefile: false,
			waterservicevalveField1: "",
			waterservicevalveFields: [],
			waterservicevalveAttributes: [],
			// water hydrant
			waterhydrantFeatureService: "",
			waterhydrantFeatureLayer: "",
			waterhydrantFeatureLayerURL: "",
			waterhydrantFeatureLayers: [],
			waterhydrantShapefile: false,
			//waterhydrantField1: "",
			waterhydrantFields: [],
			waterhydrantAttributes: [],
			//water fiiting
			watermainfittingFeatureService: "",
			watermainfittingFeatureLayer: "",
			watermainfittingFeatureLayerURL: "",
			watermainfittingFeatureLayers: [],
			watermainfittingShapefile: false,
			watermainfittingField1: "",
			watermainfittingField2: "",
			watermainfittingFields: [],
			watermainfittingAttributes: [],
			//water service fitting
			waterservicefittingFeatureService: "",
			waterservicefittingFeatureLayer: "",
			waterservicefittingFeatureLayerURL: "",
			waterservicefittingFeatureLayers: [],
			waterservicefittingShapefile: false,
			waterservicefittingField1: "",
			waterservicefittingField2: "",
			waterservicefittingFields: [],
			waterservicefittingAttributes: [],
			// electric primary overhead
			electricprimaryoverheadFeatureService: "",
			electricprimaryoverheadFeatureLayer: "",
			electricprimaryoverheadFeatureLayerURL: "",
			electricprimaryoverheadFeatureLayers: [],
			electricprimaryoverheadShapefile: false,
			electricprimaryoverheadField1: "",
			electricprimaryoverheadField2: "",
			electricprimaryoverheadField3: "",
			electricprimaryoverheadFields: [],
			electricprimaryoverheadAttributes: [],
			// electric primary underground
			electricprimaryundergroundFeatureService: "",
			electricprimaryundergroundFeatureLayer: "",
			electricprimaryundergroundFeatureLayerURL: "",
			electricprimaryundergroundFeatureLayers: [],
			electricprimaryundergroundShapefile: false,
			electricprimaryundergroundField1: "",
			electricprimaryundergroundField2: "",
			electricprimaryundergroundField3: "",
			electricprimaryundergroundFields: [],
			electricprimaryundergroundAttributes: [],
			//electric secondary overhead
			electricsecondaryoverheadFeatureService: "",
			electricsecondaryoverheadFeatureLayer: "",
			electricsecondaryoverheadFeatureLayerURL: "",
			electricsecondaryoverheadFeatureLayers: [],
			electricsecondaryoverheadShapefile: false,
			electricsecondaryoverheadField1: "",
			electricsecondaryoverheadField2: "",
			electricsecondaryoverheadField3: "",
			electricsecondaryoverheadFields: [],
			electricsecondaryoverheadAttributes: [],
			//electric secondary underground
			electricsecondaryundergroundFeatureService: "",
			electricsecondaryundergroundFeatureLayer: "",
			electricsecondaryundergroundFeatureLayerURL: "",
			electricsecondaryundergroundFeatureLayers: [],
			electricsecondaryundergroundShapefile: false,
			electricsecondaryundergroundField1: "",
			electricsecondaryundergroundField2: "",
			electricsecondaryundergroundField3: "",
			electricsecondaryundergroundFields: [],
			electricsecondaryundergroundAttributes: [],
			//electric service overhead
			electricserviceoverheadFeatureService: "",
			electricserviceoverheadFeatureLayer: "",
			electricserviceoverheadFeatureLayerURL: "",
			electricserviceoverheadFeatureLayers: [],
			electricserviceoverheadShapefile: false,
			electricserviceoverheadField1: "",
			electricserviceoverheadField2: "",
			electricserviceoverheadField3: "",
			electricserviceoverheadFields: [],
			electricserviceoverheadAttributes: [],
			// electric service underground
			electricserviceundergroundFeatureService: "",
			electricserviceundergroundFeatureLayer: "",
			electricserviceundergroundFeatureLayerURL: "",
			electricserviceundergroundFeatureLayers: [],
			electricserviceundergroundShapefile: false,
			electricserviceundergroundField1: "",
			electricserviceundergroundField2: "",
			electricserviceundergroundField3: "",
			electricserviceundergroundFields: [],
			electricserviceundergroundAttributes: [],
			// electric pole
			electricpoleFeatureService: "",
			electricpoleFeatureLayer: "",
			electricpoleFeatureLayerURL: "",
			electricpoleFeatureLayers: [],
			electricpoleShapefile: false,
			electricpoleField1: "",
			electricpoleField2: "",
			electricpoleFields: [],
			electricpoleAttributes: [],
			// electric Transformer
			electrictransformerFeatureService: "",
			electrictransformerFeatureLayer: "",
			electrictransformerFeatureLayerURL: "",
			electrictransformerFeatureLayers: [],
			electrictransformerShapefile: false,
			electrictransformerFields: [],
			electrictransformerAttributes: [],
			//electric pole transformer
			electricpoletransformerFeatureService: "",
			electricpoletransformerFeatureLayer: "",
			electricpoletransformerFeatureLayerURL: "",
			electricpoletransformerFeatureLayers: [],
			electricpoletransformerShapefile: false,
			electricpoletransformerFields: [],
			electricpoletransformerAttributes: [],
			// electric manhole
			electricmanholeFeatureService: "",
			electricmanholeFeatureLayer: "",
			electricmanholeFeatureLayerURL: "",
			electricmanholeFeatureLayers: [],
			electricmanholeShapefile: false,
			electricmanholeField1: "",
			electricmanholeField2: "",
			electricmanholeFields: [],
			electricmanholeAttributes: [],
			//gas main
			gasmainFeatureService: "",
			gasmainFeatureLayer: "",
			gasmainFeatureLayerURL: "",
			gasmainFeatureLayers: [],
			gasmainShapefile: false,
			gasmainField1: "",
			gasmainField2: "",
			gasmainField3: "",
			gasmainFields: [],
			gasmainAttributes: [],
			// gas service
			gasserviceFeatureService: "",
			gasserviceFeatureLayer: "",
			gasserviceFeatureLayerURL: "",
			gasserviceFeatureLayers: [],
			gasserviceShapefile: false,
			gasserviceField1: "",
			gasserviceField2: "",
			gasserviceField3: "",
			gasserviceFields: [],
			gasserviceAttributes: [],
			//gas service valve
			gasservicevalveFeatureService: "",
			gasservicevalveFeatureLayer: "",
			gasservicevalveFeatureLayerURL: "",
			gasservicevalveFeatureLayers: [],
			gasservicevalveShapefile: false,
			gasservicevalveField1: "",
			gasservicevalveFields: [],
			gasservicevalveAttributes: [],
			//gas main valve
			gasmainvalveFeatureService: "",
			gasmainvalveFeatureLayer: "",
			gasmainvalveFeatureLayerURL: "",
			gasmainvalveFeatureLayers: [],
			gasmainvalveShapefile: false,
			gasmainvalveField1: "",
			gasmainvalveFields: [],
			gasmainvalveAttributes: [],
			//sanitarymain
			sanitarymainFeatureService: "",
			sanitarymainFeatureLayer: "",
			sanitarymainFeatureLayerURL: "",
			sanitarymainFeatureLayers: [],
			sanitarymainShapefile: false,
			sanitarymainField1: "",
			sanitarymainField2: "",
			sanitarymainField3: "",
			sanitarymainFields: [],
			sanitarymainAttributes: [],
			//sanitary service
			sanitaryserviceFeatureService: "",
			sanitaryserviceFeatureLayer: "",
			sanitaryserviceFeatureLayerURL: "",
			sanitaryserviceFeatureLayers: [],
			sanitaryserviceShapefile: false,
			sanitaryserviceField1: "",
			sanitaryserviceField2: "",
			sanitaryserviceField3: "",
			sanitaryserviceFields: [],
			sanitaryserviceAttributes: [],
			//sanitary manhole
			sanitarymanholeFeatureService: "",
			sanitarymanholeFeatureLayer: "",
			sanitarymanholeFeatureLayerURL: "",
			sanitarymanholeFeatureLayers: [],
			sanitarymanholeShapefile: false,
			sanitarymanholeField1: "",
			sanitarymanholeField2: "",
			sanitarymanholeFields: [],
			sanitarymanholeAttributes: [],
			// sanitary catch basin
			sanitarycatchbasinFeatureService: "",
			sanitarycatchbasinFeatureLayer: "",
			sanitarycatchbasinFeatureLayerURL: "",
			sanitarycatchbasinFeatureLayers: [],
			sanitarycatchbasinShapefile: false,
			sanitarycatchbasinField1: "",
			sanitarycatchbasinField2: "",
			sanitarycatchbasinFields: [],
			sanitarycatchbasinAttributes: [],
			//storm main
			stormmainFeatureService: "",
			stormmainFeatureLayer: "",
			stormmainFeatureLayerURL: "",
			stormmainFeatureLayers: [],
			stormmainShapefile: false,
			stormmainField1: "",
			stormmainField2: "",
			stormmainField3: "",
			stormmainFields: [],
			stormmainAttributes: [],
			// storm service
			stormserviceFeatureService: "",
			stormserviceFeatureLayer: "",
			stormserviceFeatureLayerURL: "",
			stormserviceFeatureLayers: [],
			stormserviceShapefile: false,
			stormserviceField1: "",
			stormserviceField2: "",
			stormserviceField3: "",
			stormserviceFields: [],
			stormserviceAttributes: [],
			// storm catch basin
			stormcatchbasinFeatureService: "",
			stormcatchbasinFeatureLayer: "",
			stormcatchbasinFeatureLayerURL: "",
			stormcatchbasinFeatureLayers: [],
			stormcatchbasinShapefile: false,
			stormcatchbasinField1: "",
			stormcatchbasinField2: "",
			stormcatchbasinFields: [],
			stormcatchbasinAttributes: [],
			//stormmanhole
			stormmanholeFeatureService: "",
			stormmanholeFeatureLayer: "",
			stormmanholeFeatureLayerURL: "",
			stormmanholeFeatureLayers: [],
			stormmanholeShapefile: false,
			stormmanholeField1: "",
			stormmanholeField2: "",
			stormmanholeFields: [],
			stormmanholeAttributes: [],
			//fiber primary underground
			fiberprimaryundergroundFeatureService: "",
			fiberprimaryundergroundFeatureLayer: "",
			fiberprimaryundergroundFeatureLayerURL: "",
			fiberprimaryundergroundFeatureLayers: [],
			fiberprimaryundergroundShapefile: false,
			fiberprimaryundergroundField1: "",
			fiberprimaryundergroundField2: "",
			fiberprimaryundergroundField3: "",
			fiberprimaryundergroundFields: [],
			fiberprimaryundergroundAttributes: [],
			// fiberprimaryoverhead
			fiberprimaryoverheadFeatureService: "",
			fiberprimaryoverheadFeatureLayer: "",
			fiberprimaryoverheadFeatureLayerURL: "",
			fiberprimaryoverheadFeatureLayers: [],
			fiberprimaryoverheadShapefile: false,
			fiberprimaryoverheadField1: "",
			fiberprimaryoverheadField2: "",
			fiberprimaryoverheadField3: "",
			fiberprimaryoverheadFields: [],
			fiberprimaryoverheadAttributes: [],
			//fibermanhole
			fibermanholeFeatureService: "",
			fibermanholeFeatureLayer: "",
			fibermanholeFeatureLayerURL: "",
			fibermanholeFeatureLayers: [],
			fibermanholeShapefile: false,
			fibermanholeField1: "",
			fibermanholeField2: "",
			fibermanholeFields: [],
			fibermanholeAttributes: [],
			//telecomunderground
			telecomundergroundFeatureService: "",
			telecomundergroundFeatureLayer: "",
			telecomundergroundFeatureLayerURL: "",
			telecomundergroundFeatureLayers: [],
			telecomundergroundShapefile: false,
			telecomundergroundField1: "",
			telecomundergroundField2: "",
			telecomundergroundField3: "",
			telecomundergroundFields: [],
			telecomundergroundAttributes: [],
			//telecomoverhead
			telecomoverheadFeatureService: "",
			telecomoverheadFeatureLayer: "",
			telecomoverheadFeatureLayerURL: "",
			telecomoverheadFeatureLayers: [],
			telecomoverheadShapefile: false,
			telecomoverheadField1: "",
			telecomoverheadField2: "",
			telecomoverheadField3: "",
			telecomoverheadFields: [],
			telecomoverheadAttributes: [],
			//telecom manhole
			telecommanholeFeatureService: "",
			telecommanholeFeatureLayer: "",
			telecommanholeFeatureLayerURL: "",
			telecommanholeFeatureLayers: [],
			telecommanholeShapefile: false,
			telecommanholeField1: "",
			telecommanholeField2: "",
			telecommanholeFields: [],
			telecommanholeAttributes: [],
			//steam main
			steammainFeatureService: "",
			steammainFeatureLayer: "",
			steammainFeatureLayerURL: "",
			steammainFeatureLayers: [],
			steammainShapefile: false,
			steammainField1: "",
			steammainField2: "",
			steammainField3: "",
			steammainFields: [],
			steammainAttributes: [],
			//steams service
			steamserviceFeatureService: "",
			steamserviceFeatureLayer: "",
			steamserviceFeatureLayerURL: "",
			steamserviceFeatureLayers: [],
			steamserviceShapefile: false,
			steamserviceField1: "",
			steamserviceField2: "",
			steamserviceField3: "",
			steamserviceFields: [],
			steamserviceAttributes: [],
			//steam anchor
			steamanchorFeatureService: "",
			steamanchorFeatureLayer: "",
			steamanchorFeatureLayerURL: "",
			steamanchorFeatureLayers: [],
			steamanchorShapefile: false,
			steamanchorField1: "",
			steamanchorFields: [],
			steamanchorAttributes: [],
			//steamexpansionjoint
			steamexpansionjointFeatureService: "",
			steamexpansionjointFeatureLayer: "",
			steamexpansionjointFeatureLayerURL: "",
			steamexpansionjointFeatureLayers: [],
			steamexpansionjointShapefile: false,
			steamexpansionjointField1: "",
			steamexpansionjointFields: [],
			steamexpansionjointAttributes: [],
			//steam fitting
			steamfittingFeatureService: "",
			steamfittingFeatureLayer: "",
			steamfittingFeatureLayerURL: "",
			steamfittingFeatureLayers: [],
			steamfittingShapefile: false,
			steamfittingField1: "",
			steamfittingFields: [],
			steamfittingAttributes: [],
			//steamcontrolvalve
			steamcontrolvalveFeatureService: "",
			steamcontrolvalveFeatureLayer: "",
			steamcontrolvalveFeatureLayerURL: "",
			steamcontrolvalveFeatureLayers: [],
			steamcontrolvalveShapefile: false,
			steamcontrolvalveField1: "",
			steamcontrolvalveFields: [],
			steamcontrolvalveAttributes: [],
			//steam vault
			steamvaultFeatureService: "",
			steamvaultFeatureLayer: "",
			steamvaultFeatureLayerURL: "",
			steamvaultFeatureLayers: [],
			steamvaultShapefile: false,
			steamvaultField1: "",
			steamvaultFields: [],
			steamvaultAttributes: [],
			//
			modalBody: "",
			modalHeader: "",
			show: false,
			mapping: [{ "feature_service_type_id": 8, "feature_layers": [{ "feature_layer_type_id": 29, "feature_name": "territory", "feature_fields": [] }] }, 
			{ "feature_service_type_id": 10, "feature_layers": [{ "feature_layer_type_id": 45, "feature_name": "controlpoint", "feature_fields": [] }] }, { "feature_service_type_id": 1, "feature_layers": [{ "feature_layer_type_id": 1, "feature_name": "watermain", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 2, "feature_name": "waterservice", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 3, "feature_name": "waterhydrant" }, { "feature_layer_type_id": 4, "feature_name": "waterservicevalve", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }] }, { "feature_layer_type_id": 5, "feature_name": "watermainvalve", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }] }, { "feature_layer_type_id": 35, "feature_name": "watermainfitting" }, { "feature_layer_type_id": 36, "feature_name": "waterservicefitting" }] }, { "feature_service_type_id": 2, "feature_layers": [{ "feature_layer_type_id": 6, "feature_name": "electricprimaryoverhead", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 7, "feature_name": "electricprimaryunderground", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 8, "feature_name": "electricpole", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }] }, { "feature_layer_type_id": 9, "feature_name": "electrictransformer" }, { "feature_layer_type_id": 10, "feature_name": "electricmanhole", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }] }, { "feature_layer_type_id": 30, "feature_name": "electricsecondaryunderground", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 31, "feature_name": "electricsecondaryoverhead", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 32, "feature_name": "electricserviceunderground", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 33, "feature_name": "electricserviceoverhead", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 34, "feature_name": "electricpoletransformer" }] }, { "feature_service_type_id": 3, "feature_layers": [{ "feature_layer_type_id": 11, "feature_name": "gasmain", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 12, "feature_name": "gasservice", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 13, "feature_name": "gasmainvalve", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }] }, { "feature_layer_type_id": 14, "feature_name": "gasservicevalve", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }] }] }, { "feature_service_type_id": 4, "feature_layers": [{ "feature_layer_type_id": 15, "feature_name": "stormmain", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 16, "feature_name": "stormservice", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 17, "feature_name": "stormcatchbasin", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }] }, { "feature_layer_type_id": 18, "feature_name": "stormmanhole", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }] }] }, { "feature_service_type_id": 5, "feature_layers": [{ "feature_layer_type_id": 19, "feature_name": "fiberprimaryunderground", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 20, "feature_name": "fiberprimaryoverhead", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 21, "feature_name": "fibermanhole", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }] }] }, { "feature_service_type_id": 6, "feature_layers": [{ "feature_layer_type_id": 22, "feature_name": "telecomunderground", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 23, "feature_name": "telecomoverhead", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 24, "feature_name": "telecommanhole", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }] }] }, { "feature_service_type_id": 7, "feature_layers": [{ "feature_layer_type_id": 25, "feature_name": "sanitarymain", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 26, "feature_name": "sanitaryservice", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 27, "feature_name": "sanitarymanhole", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }] }] }, { "feature_service_type_id": 9, "feature_layers": [{ "feature_layer_type_id": 37, "feature_name": "steammain", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }, { "feature_layer_type_id": 38, "feature_name": "steamanchor", "feature_fields": [{ "field_type_id": 2, "field_name": "start_depth" }] }, { "feature_layer_type_id": 39, "feature_name": "steamexpansionjoint", "feature_fields": [{ "field_type_id": 2, "field_name": "start_depth" }] }, { "feature_layer_type_id": 40, "feature_name": "steamfitting", "feature_fields": [{ "field_type_id": 2, "field_name": "start_depth" }] }, { "feature_layer_type_id": 41, "feature_name": "steamcontrolvalve", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }] }, { "feature_layer_type_id": 43, "feature_name": "steamvault" }, { "feature_layer_type_id": 44, "feature_name": "steamservice", "feature_fields": [{ "field_type_id": 1, "field_name": "diameter" }, { "field_type_id": 2, "field_name": "start_depth" }, { "field_type_id": 3, "field_name": "end_depth" }] }] }],
			mappingNew: []
		}
		this.handleDropdown = this.handleDropdown.bind(this);
		this.changeRadio = this.changeRadio.bind(this);
		this.featureServiceChange = this.featureServiceChange.bind(this);
		this.featureLayerChange = this.featureLayerChange.bind(this);
		this.fieldChange = this.fieldChange.bind(this);
		this.attributeUpdate = this.attributeUpdate.bind(this);
		this.getUserMapping = this.getUserMapping.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.showModal = this.showModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	componentDidMount() {
		let value = this.context;
		if (value.userPermissions.includes("mapping:water:update")) {
			this.setState({ waterUpdate: true });
		}
		if (value.userPermissions.includes("mapping:electric:update")) {
			this.setState({ electricUpdate: true });
		}
		if (value.userPermissions.includes("mapping:gas:update")) {
			this.setState({ gasUpdate: true });
		}
		if (value.userPermissions.includes("mapping:sanitary:update")) {
			this.setState({ sanitaryUpdate: true });
		}
		if (value.userPermissions.includes("mapping:storm:update")) {
			this.setState({ stormUpdate: true });
		}
		if (value.userPermissions.includes("mapping:fiber:update")) {
			this.setState({ fiberUpdate: true });
		}
		if (value.userPermissions.includes("mapping:telecom:update")) {
			this.setState({ telecomUpdate: true });
		}
		if (value.userPermissions.includes("mapping:steam:update")) {
			this.setState({ steamUpdate: true });
		}
		if (value.userPermissions.includes("mapping:territory:update")) {
			this.setState({ territoryUpdate: true });
		}
		axios.post('https://www.arutility.com/api/v5/esri/esriServices/read.php', {}, { headers: { Authorization: 'Bearer ' + value.jwt } })
			.then(res => {
				let featureServices = res.data.services.map(featureService => {
					return { name: featureService.name }
				});
				this.setState({ featureServices: [{ name: '' }].concat(featureServices), esriFeatureServices: [{ name: '' }].concat(res.data.services), authorized: true }, this.getUserMapping);
			}).catch(error => {
				if (error.response) {
					if (error.response.status == 401) {
						this.setState({ modalBody: "Sorry there was an error: " + error.response.data.message, modalHeader: "Error", show: true, loading: false });
					} else {
						this.setState({ modalBody: "Sorry, we were unable to retrieve your feature services and feature layers from your GIS. Please try again.", modalHeader: "Error", show: true, loading: false });
					}
				} else if (error) {
					this.setState({ modalBody: "Sorry there was an error: " + error.message, modalHeader: "Error", show: true, loading: false })
				} else {
					this.setState({ modalBody: "Sorry there was an error: " + error, modalHeader: "Error", show: true, loading: false })
				}
			});
		axios.post('https://www.arutility.com/api/v5/esri/featureService/readAll.php', {}, { headers: { Authorization: 'Bearer ' + value.jwt } }).then(res => {
			console.log(res.data.message);
			this.setState({mappingNew: res.data.message});
		}).catch(error => {
			if (error.response) {
				if (error.response.status == 401) {
					this.setState({ modalBody: "Sorry there was an error: " + error.response.data.message, modalHeader: "Error", show: true, loading: false });
				} else {
					this.setState({ modalBody: "Sorry, we were unable to retrieve your feature services and feature layers from your GIS. Please try again.", modalHeader: "Error", show: true, loading: false });
				}
			} else if (error) {
				this.setState({ modalBody: "Sorry there was an error: " + error.message, modalHeader: "Error", show: true, loading: false })
			} else {
				this.setState({ modalBody: "Sorry there was an error: " + error, modalHeader: "Error", show: true, loading: false })
			}
		});
	}

	getUserMapping() {
		let value = this.context;
		//console.log(this.state);
		//console.log(this.state.esriFeatureServices);
		//console.log(this.state.featureServices);
		axios.post('https://www.arutility.com/api/v5/esri/featureService/read.php', {}, { headers: { Authorization: 'Bearer ' + value.jwt } })
			.then(res => {
				var numUserMapping = res.data.length;
				//console.log("Num User Mapping: " + numUserMapping);
				for (var i = 0; i < numUserMapping; i++) {
					//console.log("Here 518");
					//console.log(res.data[i]);
					var featureLayerIdUser = parseInt(res.data[i].feature_layer_type_id);
					var numMapping = this.state.mapping.length;
					//console.log("Num Mapping: " + numMapping);
					for (var i2 = 0; i2 < numMapping; i2++) {
						var numLayers = this.state.mapping[i2].feature_layers.length;
						//console.log("Mapping Iteration: " + i2 + " of " + numMapping);
						//console.log("Num Layers: " + numLayers);
						for (var i3 = 0; i3 < numLayers; i3++) {
							////console.log("Feature Layer Id: " + this.state.mapping[i2].feature_layers[i3].feature_layer_type_id);
							////console.log(this.state.mapping[i2].feature_layers[i3]);
							if (this.state.mapping[i2].feature_layers[i3].feature_layer_type_id == featureLayerIdUser) {
								//console.log("Feature Layer Type Matches");
								var featureName = this.state.mapping[i2].feature_layers[i3].feature_name;
								var featureLayerName = res.data[i].feature_layer_name;
								var featureServiceName = res.data[i].feature_service_name;
								var featureShapefile = parseInt(res.data[i].shapefile);
								var featureLayerURL = res.data[i].feature_layer_url;
								var featureLayerAttributes = res.data[i].attributes;
								var attributeArray = featureLayerAttributes.split(',');
								this.state[featureName + "Attributes"] = attributeArray;

								// setting fields
								if (this.state.mapping[i2].feature_layers[i3].feature_fields) {
									var numFields = this.state.mapping[i2].feature_layers[i3].feature_fields.length;
									var numMappedFields = res.data[i].fields.length;
									for (var i4 = 0; i4 < numFields; i4++) {
										for (var i5 = 0; i5 < numMappedFields; i5++) {
											if (res.data[i].fields[i5].field_type_id == this.state.mapping[i2].feature_layers[i3].feature_fields[i4].field_type_id) {
												var fieldTypeId = res.data[i].fields[i5].field_type_id;
												var fieldAlias = res.data[i].fields[i5].alias;
												this.setState({ [featureName + "Field" + fieldTypeId]: fieldAlias });
											}
										}
									}
								}
								var numEsriServices = this.state.esriFeatureServices.length;
								//console.log("Num Esri Services: " + numEsriServices);
								for (var i4 = 0; i4 < numEsriServices; i4++) {
									if (this.state.esriFeatureServices[i4].name == featureServiceName) {
										let layers = this.state.esriFeatureServices[i4].layers.map(layer => {
											return { name: layer.name, geometryType: layer.geometryType };
										});
										this.setState({ [featureName + "FeatureLayers"]: [{ name: '', geometryType: '' }].concat(layers) });
										var numLayers = this.state.esriFeatureServices[i4].layers.length;
										for (var i5 = 0; i5 < numLayers; i5++) {
											if (this.state.esriFeatureServices[i4].layers[i5].name == featureLayerName) {
												let fields = this.state.esriFeatureServices[i4].layers[i5].fields.map(field => {
													return { name: field.name, type: field.type };
												});
												this.setState({ [featureName + "Fields"]: [{ name: '', type: '' }].concat(fields) });
											}
										}
										break;
									}
								}
								this.setState({
									[featureName + "FeatureLayer"]: featureLayerName,
									[featureName + "FeatureService"]: featureServiceName,
									[featureName + "FeatureLayerURL"]: featureLayerURL,
									[featureName + "Shapefile"]: featureShapefile
								});
								break;
							}
						}
					}
				}
				this.setState({ loading: false });
				//console.log(this.state);
			}).catch(error => {
				//console.log(error);
				if (error.response) {
					if (error.response.status == 401) {
						this.setState({ loading: false });
					} else {
						this.setState({ modalBody: "Sorry, we were unable to retrieve your feature services and feature layers from your GIS. Please try again.", modalHeader: "Error", show: true, loading: false });
					}
				} else if (error) {
					this.setState({ modalBody: "Sorry there was an error: " + error.message, modalHeader: "Error", show: true, loading: false })
				} else {
					this.setState({ modalBody: "Sorry there was an error: " + error, modalHeader: "Error", show: true, loading: false })
				}
			});
	}

	featureServiceChange(e) {
		var featureServiceTypeId = e.target.parentElement.parentElement.getAttribute('data-feature_service_type_id');
		var featureLayerTypeId = e.target.parentElement.parentElement.getAttribute('data-feature_layer_type_id');
		var featureLayer = e.target.id + "FeatureLayer";
		var featureLayerURL = e.target.id + "FeatureLayerURL";
		var featureLayers = e.target.id + "FeatureLayers";
		var numMapping = this.state.mapping.length;
		for (var i = 0; i < numMapping; i++) {
			if (this.state.mapping[i].feature_service_type_id == featureServiceTypeId) {
				var numLayers = this.state.mapping[i].feature_layers.length;
				for (var i2 = 0; i2 < numLayers; i2++) {
					if (this.state.mapping[i].feature_layers[i2].feature_layer_type_id == featureLayerTypeId) {
						if (this.state.mapping[i].feature_layers[i2].feature_fields) {
							var numFields = this.state.mapping[i].feature_layers[i2].feature_fields.length;
							for (var i3 = 0; i3 < numFields; i3++) {
								var fieldTypeId = this.state.mapping[i].feature_layers[i2].feature_fields[i3].field_type_id;
								var featureLayerField = e.target.id + "Field" + fieldTypeId;
								if (this.state[featureLayerField]) {
									this.setState({ [featureLayerField]: "" });
								}
							}
						}
					}
				}
			}
		}
		var featureLayerFields = e.target.id + "Fields";
		this.setState({ [e.target.name]: e.target.value, [featureLayer]: "", [featureLayerURL]: "" });
		var numServices = this.state.esriFeatureServices.length;
		for (var i = 0; i < numServices; i++) {
			if (this.state.esriFeatureServices[i].name == e.target.value) {
				let layers = this.state.esriFeatureServices[i].layers.map(layer => {
					return { name: layer.name, geometryType: layer.geometryType };
				});
				this.setState({ [featureLayers]: [{ name: '', geometryType: '' }].concat(layers), [featureLayerFields]: [] });
			}
		}
	}

	featureLayerChange(e) {
		var featureServiceTypeId = e.target.parentElement.parentElement.getAttribute('data-feature_service_type_id');
		var featureLayerTypeId = e.target.parentElement.parentElement.getAttribute('data-feature_layer_type_id');
		var featureService = this.state[e.target.id + "FeatureService"];
		var featureLayer = e.target.value;
		var featureLayerURL = e.target.id + "FeatureLayerURL";
		var featureLayers = e.target.id + "FeatureLayers";
		var featureFields = e.target.id + "Fields";
		this.setState({ [e.target.id + "Attributes"]: [], [featureFields]: [] });
		var numMapping = this.state.mapping.length;
		for (var i = 0; i < numMapping; i++) {
			if (this.state.mapping[i].feature_service_type_id == featureServiceTypeId) {
				var numLayers = this.state.mapping[i].feature_layers.length;
				for (var i2 = 0; i2 < numLayers; i2++) {
					if (this.state.mapping[i].feature_layers[i2].feature_layer_type_id == featureLayerTypeId) {
						if (this.state.mapping[i].feature_layers[i2].feature_fields) {
							var numFields = this.state.mapping[i].feature_layers[i2].feature_fields.length;
							for (var i3 = 0; i3 < numFields; i3++) {
								var fieldTypeId = this.state.mapping[i].feature_layers[i2].feature_fields[i3].field_type_id;
								var featureLayerField = e.target.id + "Field" + fieldTypeId;
								if (this.state[featureLayerField]) {
									this.setState({ [featureLayerField]: "" });
								}
							}
						}
					}
				}
			}
		}
		this.setState({ [e.target.name]: e.target.value });
		var numServices = this.state.esriFeatureServices.length;
		for (var i = 0; i < numServices; i++) {
			if (this.state.esriFeatureServices[i].name == featureService) {
				var numLayers = this.state.esriFeatureServices[i].layers.length;
				for (var i2 = 0; i2 < numLayers; i2++) {
					if (this.state.esriFeatureServices[i].layers[i2].name == featureLayer) {
						var serviceURL = this.state.esriFeatureServices[i].url;
						var layerId = this.state.esriFeatureServices[i].layers[i2].id;
						var layerURL = serviceURL + "/" + layerId;
						let fields = this.state.esriFeatureServices[i].layers[i2].fields.map(field => {
							return { name: field.name, type: field.type };
						});
						this.setState({ [featureFields]: [{ name: '', type: '' }].concat(fields), [featureLayerURL]: layerURL });
					}
				}
			}
		}
	}

	fieldChange(e) {
		var fieldName = e.target.id + "Field" + e.target.getAttribute('data-field_type_id');
		this.setState({ [fieldName]: e.target.value });
	}

	attributeUpdate(e) {
		var fieldName = e.target.id + "Attributes";
		var attributeArray = this.state[fieldName];
		if (!attributeArray.includes(e.target.value)) {
			attributeArray.push(e.target.value);
		} else {
			var index = attributeArray.indexOf(e.target.value);
			if (index > -1) {
				attributeArray.splice(index, 1);
			}
		}
		this.setState({ [fieldName]: attributeArray });
		////console.log(attributeArray);
	}

	handleDropdown(e) {
		var elementName = e.target.id + "Wrapper";
		let element = document.getElementById(elementName);
		if (this.state[e.target.id] == false) {
			ReactDOM.findDOMNode(element).style.display = "block";
			this.setState({ [e.target.id]: true });
		} else {
			ReactDOM.findDOMNode(element).style.display = "none";
			this.setState({ [e.target.id]: false });
		}
	}

	changeRadio(e) {
		var radioName = e.target.id + "Shapefile";
		if (this.state[radioName] == false) {
			this.setState({ [radioName]: true });
		} else {
			this.setState({ [radioName]: false });
		}
	}

	handleSubmit() {
		this.setState({ loading: true });
		let value = this.context;
		var mapping = [];
		var numServices = this.state.mapping.length;
		for (var i = 0; i < numServices; i++) {
			var numLayers = this.state.mapping[i].feature_layers.length;
			for (var i2 = 0; i2 < numLayers; i2++) {
				var featureLayer = this.state.mapping[i].feature_layers[i2].feature_name;
				var featureServiceName = this.state[featureLayer + "FeatureService"];
				var featureLayerName = this.state[featureLayer + "FeatureLayer"];
				var featureLayerURL = this.state[featureLayer + "FeatureLayerURL"];
				var featureShapefile = this.state[featureLayer + "Shapefile"];
				var featureAttributes = this.state[featureLayer + "Attributes"];
				var fields = [];
				if (this.state.mapping[i].feature_layers[i2].feature_fields) {
					var numFields = this.state.mapping[i].feature_layers[i2].feature_fields.length;
					for (var i3 = 0; i3 < numFields; i3++) {
						if (this.state[featureLayer + "Field" + this.state.mapping[i].feature_layers[i2].feature_fields[i3].field_type_id]) {
							var featureField = this.state[featureLayer + "Field" + this.state.mapping[i].feature_layers[i2].feature_fields[i3].field_type_id];
							var field = { "field_type_id": this.state.mapping[i].feature_layers[i2].feature_fields[i3].field_type_id, "field_name": featureField };
							fields.push(field);
						}
					}
				}
				var featureService = {
					"feature_service_type_id": this.state.mapping[i].feature_service_type_id,
					"feature_layer_type_id": this.state.mapping[i].feature_layers[i2].feature_layer_type_id,
					"feature_service_name": featureServiceName, "feature_layer_name": featureLayerName,
					"feature_layer_url": featureLayerURL, "allow_shapefiles": featureShapefile,
					"fields": fields, "attributes": featureAttributes
				};
				mapping.push(featureService);
			}
		}
		axios.post('https://www.arutility.com/api/v5/accounts/mapping/update.php', { mapping: mapping }, { headers: { Authorization: 'Bearer ' + value.jwt } })
			.then(res => {
				this.setState({ loading: false, modalBody: "Mapping successfully updated", modalHeader: "Success", show: true });
			}).catch(error => {
				if (error.response) {
					this.setState({ loading: false, modalBody: "Sorry, there was an error. " + error.response.data, modalHeader: "Error", show: true });
				} else if (error.request) {
					// The request was made but no response was received
					this.setState({ loading: false, modalBody: "Sorry, there was an error. " + error.request, modalHeader: "Error", show: true });
				} else {
					// Something happened in setting up the request that triggered an Error
					this.setState({ loading: false, modalBody: "Sorry, there was an error. " + error.message, modalHeader: "Error", show: true });
				}
			});
	}

	showModal() {
		this.setState({ show: true });
	}

	closeModal() {
		this.setState({ show: false });
	}

	render() {
		const { loading, authorized, show } = this.state;
		let value = this.context;
		if (value.jwt == "") {
			return (
				<Route>
					<Redirect to="/login" />
				</Route>
			);
		} else {
			if (value.userPermissions.includes("mapping:update")) {
				return (
					<div className="mainWrapper">
						<div className="mainWindow">
							{this.state.loading &&
							<LoadingSpinner />
							}
							<Modal show={show} onHide={this.closeModal}>
								<Modal.Header closeButton>
									<Modal.Title>{this.state.modalHeader}</Modal.Title>
								</Modal.Header>
								<Modal.Body>{this.state.modalBody}</Modal.Body>
								<Modal.Footer>
									<Button variant="secondary" onClick={this.closeModal}>
										Close
					              </Button>
								</Modal.Footer>
							</Modal>
							<div className="pageHeader">
								UTILITY MAPPING
					      	</div>
							<div className="plainBody">
								Please map your utilities with the appropriate ARUtility layers below. First select the appropriate feature service that contains the correct layer. Once you've selected a feature service, the available feature layers will be loaded.

								If you do not have any data to map to a specific ARUtility layer, leave the drop down blank and it will be ignored. ARUtility handles field validation. Only fields with data types that match those supported by ARUtilty will be displayed.
								<br />
								<br />
								Diameter field units must be in inches. Height field units must be in feet. Heights and depths are relative to the ground surface. Values may be either negative or positive, ARUtility will handle any necessary conversions for display in augmented reality.
								<br />
								<br />
								{this.state.territoryUpdate &&
									<div className="featureServiceWrapper">
										<div className="selectionHeader" id="territoryDropdown" onClick={this.handleDropdown}>
											GENERAL
						                	<img id="territoryDropdown" className="downCarrotShow" src="/images/downcarrotblack.png" />
										</div>
										<div id="layerOptionWrapperGeneral" className="featureServiceDropdownWrapper" id="territoryDropdownWrapper" >
											<div className="layerOptionWrapper" data-feature_service_type_id="8" data-feature_layer_type_id="29" data-feature_type="polygon">
												<div className="layerHeader">
													Service Territory
						                        </div>
												<div className="layerSelection">
													Territory Feature Service:
							                        <select id="territory" className="featureServiceName" data-feature_service_type_id="8" name="territoryFeatureService" onChange={this.featureServiceChange} value={this.state.territoryFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="territory" className="featureLayerName" name="territoryFeatureLayer" onChange={this.featureLayerChange} value={this.state.territoryFeatureLayer}>
														{this.state.territoryFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolygon" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="10" data-feature_layer_type_id="45" data-feature_type="point">
												<div className="layerHeader">
													Control Points
						                        </div>
												<div className="layerSelection">
													Control Point Feature Service:
							                        <select id="controlpoint" className="featureServiceName" data-feature_service_type_id="10" name="controlpointFeatureService" onChange={this.featureServiceChange} value={this.state.controlpointFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="controlpoint" className="featureLayerName" name="controlpointFeatureLayer" onChange={this.featureLayerChange} value={this.state.controlpointFeatureLayer}>
														{this.state.controlpointFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.controlpointFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="controlpoint" type="checkbox" className="featureSelectedCheckbox" checked={this.state.controlpointAttributes.includes(field.name)} value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
								}
								{this.state.waterUpdate &&
									<div className="featureServiceWrapper">
										<div className="selectionHeader" id="waterDropdown" onClick={this.handleDropdown}>
											WATER
						                	<img id="waterDropdown" className="downCarrotShow" src="/images/downcarrotblack.png" />
										</div>
										<div id="layerOptionWrapperGeneral" className="featureServiceDropdownWrapper" id="waterDropdownWrapper">
											<div className="layerOptionWrapper" data-feature_service_type_id="1" data-feature_layer_type_id="1" data-feature_type="line">
												<div className="layerHeader">Water Main</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="watermain" data-feature_service_type_id="1" className="featureServiceName" name="watermainFeatureService" onChange={this.featureServiceChange} value={this.state.watermainFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="watermain" className="featureLayerName" name="watermainFeatureLayer" onChange={this.featureLayerChange} value={this.state.watermainFeatureLayer}>
														{this.state.watermainFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="watermain" className="featureFieldName" name="watermainField" data-field_type_id="1" onChange={this.fieldChange} value={this.state.watermainField1}>
														{this.state.watermainFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Start Depth:
							                        <select id="watermain" className="featureFieldName" name="watermainField" data-field_type_id="2" onChange={this.fieldChange} value={this.state.watermainField2}>
														{this.state.watermainFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Depth:
							                        <select id="watermain" className="featureFieldName" name="watermainField" data-field_type_id="3" onChange={this.fieldChange} value={this.state.watermainField3}>
														{this.state.watermainFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="watermain" type="checkbox" name="watermainShapefile" className="featureSelectedCheckbox" checked={this.state.watermainShapefile} onChange={this.changeRadio} readOnly />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.watermainFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name} key={field.name}>
																<input id="watermain" type="checkbox" className="featureSelectedCheckbox" checked={this.state.watermainAttributes.includes(field.name)} value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="1" data-feature_layer_type_id="2" data-feature_type="line">
												<div className="layerHeader">Water Service</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="waterservice" className="featureServiceName" name="waterserviceFeatureService" onChange={this.featureServiceChange} value={this.state.waterserviceFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="waterservice" className="featureLayerName" name="waterserviceFeatureLayer" onChange={this.featureLayerChange} value={this.state.waterserviceFeatureLayer}>
														{this.state.waterserviceFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="waterservice" className="featureFieldName" name="waterserviceField" data-field_type_id="1" onChange={this.fieldChange} value={this.state.waterserviceField1}>
														{this.state.waterserviceFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Start Depth:
							                        <select id="waterservice" className="featureFieldName" name="waterserviceField" data-field_type_id="2" onChange={this.fieldChange} value={this.state.waterserviceField2}>
														{this.state.waterserviceFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Depth:
							                        <select id="waterservice" className="featureFieldName" name="waterserviceField" data-field_type_id="3" onChange={this.fieldChange} value={this.state.waterserviceField3}>
														{this.state.waterserviceFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="waterservice" type="checkbox" name="waterserviceShapefile" className="featureSelectedCheckbox" checked={this.state.waterserviceShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.waterserviceFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="waterservice" type="checkbox" className="featureSelectedCheckbox" checked={this.state.waterserviceAttributes.includes(field.name)} value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="1" data-feature_layer_type_id="5" data-feature_type="point">
												<div className="layerHeader">Water Main Valves</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="watermainvalve" className="featureServiceName" name="watermainvalveFeatureService" onChange={this.featureServiceChange} value={this.state.watermainvalveFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="watermainvalve" className="featureLayerName" name="watermainvalveFeatureLayer" onChange={this.featureLayerChange} value={this.state.watermainvalveFeatureLayer}>
														{this.state.watermainvalveFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="watermainvalve" className="featureFieldName" data-field_type_id="1" name="watermainvalveField" data-field_type_id="1" onChange={this.fieldChange} value={this.state.watermainvalveField1}>
														{this.state.watermainvalveFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="watermainvalve" type="checkbox" name="watermainvalveShapefile" className="featureSelectedCheckbox" checked={this.state.watermainvalveShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.watermainvalveFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="watermainvalve" type="checkbox" checked={this.state.watermainvalveAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="1" data-feature_layer_type_id="4" data-feature_type="point">
												<div className="layerHeader">Water Service Valves</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="waterservicevalve" className="featureServiceName" name="waterservicevalveFeatureService" onChange={this.featureServiceChange} value={this.state.waterservicevalveFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="waterservicevalve" className="featureLayerName" name="waterservicevalveFeatureLayer" onChange={this.featureLayerChange} value={this.state.waterservicevalveFeatureLayer}>
														{this.state.waterservicevalveFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="waterservicevalve" className="featureFieldName" data-field_type_id="1" name="waterservicevalveField" onChange={this.fieldChange} value={this.state.waterservicevalveField1}>
														{this.state.waterservicevalveFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="waterservicevalve" type="checkbox" name="waterservicevalveShapefile" className="featureSelectedCheckbox" checked={this.state.waterservicevalveShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.waterservicevalveFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="waterservicevalve" type="checkbox" checked={this.state.waterservicevalveAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="1" data-feature_layer_type_id="3" data-feature_type="point">
												<div className="layerHeader">Fire Hydrant</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="waterhydrant" className="featureServiceName" name="waterhydrantFeatureService" onChange={this.featureServiceChange} value={this.state.waterhydrantFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="waterhydrant" className="featureLayerName" name="waterhydrantFeatureLayer" onChange={this.featureLayerChange} value={this.state.waterhydrantFeatureLayer}>
														{this.state.waterhydrantFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="waterhydrant" type="checkbox" name="waterhydrantShapefile" className="featureSelectedCheckbox" checked={this.state.waterhydrantShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.waterhydrantFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="waterhydrant" type="checkbox" checked={this.state.waterhydrantAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="1" data-feature_layer_type_id="35" data-feature_type="point">
												<div className="layerHeader">Water Main Fitting</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="watermainfitting" className="featureServiceName" name="watermainfittingFeatureService" onChange={this.featureServiceChange} value={this.state.watermainfittingFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="watermainfitting" className="featureLayerName" name="watermainfittingFeatureLayer" onChange={this.featureLayerChange} value={this.state.watermainfittingFeatureLayer}>
														{this.state.watermainfittingFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Depth:
							                        <select id="watermainfitting" className="featureFieldName" data-field_type_id="2" name="watermainfittingField" onChange={this.fieldChange} value={this.state.watermainvalveField2}>
														{this.state.watermainfittingFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="watermainfitting" type="checkbox" name="watermainfittingShapefile" className="featureSelectedCheckbox" checked={this.state.watermainfittingShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.watermainfittingFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="watermainfitting" type="checkbox" checked={this.state.watermainfittingAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="1" data-feature_layer_type_id="36" data-feature_type="point">
												<div className="layerHeader">Water Service Fitting</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="waterservicefitting" className="featureServiceName" name="waterservicefittingFeatureService" onChange={this.featureServiceChange} value={this.state.waterservicefittingFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="waterservicefitting" className="featureLayerName" name="waterservicefittingFeatureLayer" onChange={this.featureLayerChange} value={this.state.waterservicefittingFeatureLayer}>
														{this.state.waterservicefittingFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Depth:
							                        <select id="waterservicefitting" className="featureFieldName" data-field_type_id="2" name="waterservicefittingField" onChange={this.fieldChange} value={this.state.waterservicevalveField2}>
														{this.state.waterservicefittingFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="waterservicefitting" type="checkbox" name="waterservicefittingShapefile" className="featureSelectedCheckbox" checked={this.state.waterservicefittingShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.waterservicefittingFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="waterservicefitting" type="checkbox" checked={this.state.waterservicefittingAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
								}
								{this.state.electricUpdate &&
									<div className="featureServiceWrapper">
										<div className="selectionHeader" id="electricDropdown" onClick={this.handleDropdown}>
											ELECTRIC
						                	<img id="electricDropdown" className="downCarrotShow" src="/images/downcarrotblack.png" />
										</div>
										<div id="layerOptionWrapperGeneral" className="featureServiceDropdownWrapper" id="electricDropdownWrapper">
											<div className="layerOptionWrapper" data-feature_service_type_id="2" data-feature_layer_type_id="6" data-feature_type="line">
												<div className="layerHeader">Electric Primary Overhead</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="electricprimaryoverhead" data-feature_service_type_id="2" className="featureServiceName" name="electricprimaryoverheadFeatureService" onChange={this.featureServiceChange} value={this.state.electricprimaryoverheadFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="electricprimaryoverhead" className="featureLayerName" name="electricprimaryoverheadFeatureLayer" onChange={this.featureLayerChange} value={this.state.electricprimaryoverheadFeatureLayer}>
														{this.state.electricprimaryoverheadFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Start Height:
							                        <select id="electricprimaryoverhead" className="featureFieldName" data-field_type_id="2" name="electricprimaryoverheadField" onChange={this.fieldChange} value={this.state.electricprimaryoverheadField2}>
														{this.state.electricprimaryoverheadFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Height:
							                        <select id="electricprimaryoverhead" className="featureFieldName" data-field_type_id="3" name="electricprimaryoverheadField" onChange={this.fieldChange} value={this.state.electricprimaryoverheadField3}>
														{this.state.electricprimaryoverheadFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="electricprimaryoverhead" type="checkbox" name="electricprimaryoverheadShapefile" className="featureSelectedCheckbox" checked={this.state.electricprimaryoverheadShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.electricprimaryoverheadFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="electricprimaryoverhead" type="checkbox" checked={this.state.electricprimaryoverheadAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="2" data-feature_layer_type_id="7" data-feature_type="line">
												<div className="layerHeader">Electric Primary Underground</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="electricprimaryunderground" className="featureServiceName" name="electricprimaryundergroundFeatureService" onChange={this.featureServiceChange} value={this.state.electricprimaryundergroundFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="electricprimaryunderground" className="featureLayerName" name="electricprimaryundergroundFeatureLayer" onChange={this.featureLayerChange} value={this.state.electricprimaryundergroundFeatureLayer}>
														{this.state.electricprimaryundergroundFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Start Depth:
							                        <select id="electricprimaryunderground" className="featureFieldName" data-field_type_id="2" name="electricprimaryundergroundField" onChange={this.fieldChange} value={this.state.electricprimaryundergroundField2}>
														{this.state.electricprimaryundergroundFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Depth:
							                        <select id="electricprimaryunderground" className="featureFieldName" data-field_type_id="3" name="electricprimaryundergroundField" onChange={this.fieldChange} value={this.state.electricprimaryundergroundField3}>
														{this.state.electricprimaryundergroundFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="electricprimaryunderground" type="checkbox" name="electricprimaryundergroundShapefile" className="featureSelectedCheckbox" checked={this.state.electricprimaryundergroundShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.electricprimaryundergroundFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="electricprimaryunderground" type="checkbox" checked={this.state.electricprimaryundergroundAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="2" data-feature_layer_type_id="31" data-feature_type="line">
												<div className="layerHeader">Electric Secondary Overhead</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="electricsecondaryoverhead" className="featureServiceName" name="electricsecondaryoverheadFeatureService" onChange={this.featureServiceChange} value={this.state.electricsecondaryoverheadFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="electricsecondaryoverhead" className="featureLayerName" name="electricsecondaryoverheadFeatureLayer" onChange={this.featureLayerChange} value={this.state.electricsecondaryoverheadFeatureLayer}>
														{this.state.electricsecondaryoverheadFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Start Height:
							                        <select id="electricsecondaryoverhead" className="featureFieldName" data-field_type_id="2" name="electricsecondaryoverheadField" onChange={this.fieldChange} value={this.state.electricsecondaryoverheadField2}>
														{this.state.electricsecondaryoverheadFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Height:
							                        <select id="electricsecondaryoverhead" className="featureFieldName" data-field_type_id="3" name="electricsecondaryoverheadField" onChange={this.fieldChange} value={this.state.electricsecondaryoverheadField3}>
														{this.state.electricsecondaryoverheadFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="electricsecondaryoverhead" type="checkbox" name="electricsecondaryoverheadShapefile" className="featureSelectedCheckbox" checked={this.state.electricsecondaryoverheadShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.electricsecondaryoverheadFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="electricsecondaryoverhead" type="checkbox" checked={this.state.electricsecondaryoverheadAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="2" data-feature_layer_type_id="30" data-feature_type="line">
												<div className="layerHeader">Electric Secondary Underground</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="electricsecondaryunderground" className="featureServiceName" name="electricsecondaryundergroundFeatureService" onChange={this.featureServiceChange} value={this.state.electricsecondaryundergroundFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="electricsecondaryunderground" className="featureLayerName" name="electricsecondaryundergroundFeatureLayer" onChange={this.featureLayerChange} value={this.state.electricsecondaryundergroundFeatureLayer}>
														{this.state.electricsecondaryundergroundFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Start Depth:
							                        <select id="electricsecondaryunderground" className="featureFieldName" data-field_type_id="2" name="electricsecondaryundergroundField" onChange={this.fieldChange} value={this.state.electricsecondaryundergroundField2}>
														{this.state.electricsecondaryundergroundFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Depth:
							                        <select id="electricsecondaryunderground" className="featureFieldName" data-field_type_id="3" name="electricsecondaryundergroundField" onChange={this.fieldChange} value={this.state.electricsecondaryundergroundField3}>
														{this.state.electricsecondaryundergroundFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="electricsecondaryunderground" type="checkbox" name="electricsecondaryundergroundShapefile" className="featureSelectedCheckbox" checked={this.state.electricsecondaryundergroundShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.electricsecondaryundergroundFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="electricsecondaryunderground" type="checkbox" checked={this.state.electricsecondaryundergroundAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="2" data-feature_layer_type_id="33" data-feature_type="line">
												<div className="layerHeader">Electric Service Overhead</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="electricserviceoverhead" className="featureServiceName" name="electricserviceoverheadFeatureService" onChange={this.featureServiceChange} value={this.state.electricserviceoverheadFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="electricserviceoverhead" className="featureLayerName" name="electricserviceoverheadFeatureLayer" onChange={this.featureLayerChange} value={this.state.electricserviceoverheadFeatureLayer}>
														{this.state.electricserviceoverheadFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Start Height:
							                        <select id="electricserviceoverhead" className="featureFieldName" data-field_type_id="2" name="electricserviceoverheadField" onChange={this.fieldChange} value={this.state.electricserviceoverheadField2}>
														{this.state.electricserviceoverheadFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Height:
							                        <select id="electricserviceoverhead" className="featureFieldName" data-field_type_id="3" name="electricserviceoverheadField" onChange={this.fieldChange} value={this.state.electricserviceoverheadField3}>
														{this.state.electricserviceoverheadFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="electricserviceoverhead" type="checkbox" name="electricserviceoverheadShapefile" className="featureSelectedCheckbox" checked={this.state.electricserviceoverheadShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.electricserviceoverheadFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="electricserviceoverhead" type="checkbox" checked={this.state.electricserviceoverheadAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="2" data-feature_layer_type_id="32" data-feature_type="line">
												<div className="layerHeader">Electric Service Underground</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="electricserviceunderground" className="featureServiceName" name="electricserviceundergroundFeatureService" onChange={this.featureServiceChange} value={this.state.electricserviceundergroundFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="electricserviceunderground" className="featureLayerName" name="electricserviceundergroundFeatureLayer" onChange={this.featureLayerChange} value={this.state.electricserviceundergroundFeatureLayer}>
														{this.state.electricserviceundergroundFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Start Depth:
							                        <select id="electricserviceunderground" className="featureFieldName" data-field_type_id="2" name="electricserviceundergroundField" onChange={this.fieldChange} value={this.state.electricserviceundergroundField2}>
														{this.state.electricserviceundergroundFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Depth:
							                        <select id="electricserviceunderground" className="featureFieldName" data-field_type_id="3" name="electricserviceundergroundField" onChange={this.fieldChange} value={this.state.electricserviceundergroundField3}>
														{this.state.electricserviceundergroundFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="electricserviceunderground" type="checkbox" name="electricserviceundergroundShapefile" className="featureSelectedCheckbox" checked={this.state.electricserviceundergroundShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.electricserviceundergroundFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="electricserviceunderground" type="checkbox" checked={this.state.electricserviceundergroundAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="2" data-feature_layer_type_id="8" data-feature_type="point">
												<div className="layerHeader">Electric Pole</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="electricpole" className="featureServiceName" name="electricpoleFeatureService" onChange={this.featureServiceChange} value={this.state.electricpoleFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="electricpole" className="featureLayerName" name="electricpoleFeatureLayer" onChange={this.featureLayerChange} value={this.state.electricpoleFeatureLayer}>
														{this.state.electricpoleFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="electricpole" className="featureFieldName" data-field_type_id="1" name="electricpoleField" onChange={this.fieldChange} value={this.state.electricpoleField1}>
														{this.state.electricpoleFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Height:
							                        <select id="electricpole" className="featureFieldName" data-field_type_id="2" name="electricpoleField" onChange={this.fieldChange} value={this.state.electricpoleField2}>
														{this.state.electricpoleFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="electricpole" type="checkbox" name="electricpoleShapefile" className="featureSelectedCheckbox" checked={this.state.electricpoleShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.electricpoleFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="electricpole" type="checkbox" checked={this.state.electricpoleAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="2" data-feature_layer_type_id="9" data-feature_type="point">
												<div className="layerHeader">Electric Pad Mount Transformer</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="electrictransformer" className="featureServiceName" name="electrictransformerFeatureService" onChange={this.featureServiceChange} value={this.state.electrictransformerFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="electrictransformer" className="featureLayerName" name="electrictransformerFeatureLayer" onChange={this.featureLayerChange} value={this.state.electrictransformerFeatureLayer}>
														{this.state.electrictransformerFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="electrictransformer" type="checkbox" name="electrictransformerShapefile" className="featureSelectedCheckbox" checked={this.state.electrictransformerShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.electrictransformerFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="electrictransformer" type="checkbox" checked={this.state.electrictransformerAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="2" data-feature_layer_type_id="34" data-feature_type="point">
												<div className="layerHeader">Electric Pole Mount Transformer</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="electricpoletransformer" className="featureServiceName" name="electricpoletransformerFeatureService" onChange={this.featureServiceChange} value={this.state.electricpoletransformerFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="electricpoletransformer" className="featureLayerName" name="electricpoletransformerFeatureLayer" onChange={this.featureLayerChange} value={this.state.electricpoletransformerFeatureLayer}>
														{this.state.electricpoletransformerFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="electricpoletransformer" type="checkbox" name="electricpoletransformerShapefile" className="featureSelectedCheckbox" checked={this.state.electricpoletransformerShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.electricpoletransformerFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="electricpoletransformer" type="checkbox" checked={this.state.electricpoletransformerAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="2" data-feature_layer_type_id="10" data-feature_type="point">
												<div className="layerHeader">Electric Manhole</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="electricmanhole" className="featureServiceName" name="electricmanholeFeatureService" onChange={this.featureServiceChange} value={this.state.electricmanholeFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="electricmanhole" className="featureLayerName" name="electricmanholeFeatureLayer" onChange={this.featureLayerChange} value={this.state.electricmanholeFeatureLayer}>
														{this.state.electricmanholeFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="electricmanhole" className="featureFieldName" data-field_type_id="1" name="electricmanholeField" onChange={this.fieldChange} value={this.state.electricmanholeField1}>
														{this.state.electricmanholeFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Depth:
							                        <select id="electricmanhole" className="featureFieldName" data-field_type_id="2" name="electricmanholeField" onChange={this.fieldChange} value={this.state.electricmanholeField2}>
														{this.state.electricmanholeFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="electricmanhole" type="checkbox" name="electricmanholeShapefile" className="featureSelectedCheckbox" checked={this.state.electricmanholeShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.electricmanholeFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="electricmanhole" type="checkbox" checked={this.state.electricmanholeAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
								}
								{this.state.gasUpdate &&
									<div className="featureServiceWrapper">
										<div className="selectionHeader" id="gasDropdown" onClick={this.handleDropdown}>
											GAS
						                	<img id="gasDropdown" className="downCarrotShow" src="/images/downcarrotblack.png" />
										</div>
										<div id="layerOptionWrapperGeneral" className="featureServiceDropdownWrapper" id="gasDropdownWrapper">
											<div className="layerOptionWrapper" data-feature_service_type_id="3" data-feature_layer_type_id="11" data-feature_type="line">
												<div className="layerHeader">Gas Main</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="gasmain" className="featureServiceName" data-feature_service_type_id="3" name="gasmainFeatureService" onChange={this.featureServiceChange} value={this.state.gasmainFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="gasmain" className="featureLayerName" name="gasmainFeatureLayer" onChange={this.featureLayerChange} value={this.state.gasmainFeatureLayer}>
														{this.state.gasmainFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="gasmain" className="featureFieldName" data-field_type_id="1" name="gasmainField" onChange={this.fieldChange} value={this.state.gasmainField1}>
														{this.state.gasmainFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Start Depth:
							                        <select id="gasmain" className="featureFieldName" data-field_type_id="2" name="gasmainField" onChange={this.fieldChange} value={this.state.gasmainField2}>
														{this.state.gasmainFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Depth:
							                        <select id="gasmain" className="featureFieldName" data-field_type_id="3" name="gasmainField" onChange={this.fieldChange} value={this.state.gasmainField3}>
														{this.state.gasmainFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="gasmain" type="checkbox" name="gasmainShapefile" className="featureSelectedCheckbox" checked={this.state.gasmainShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.gasmainFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="gasmain" type="checkbox" checked={this.state.gasmainAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="3" data-feature_layer_type_id="12" data-feature_type="line">
												<div className="layerHeader">Gas Service</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="gasservice" className="featureServiceName" name="gasserviceFeatureService" onChange={this.featureServiceChange} value={this.state.gasserviceFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="gasservice" className="featureLayerName" name="gasserviceFeatureLayer" onChange={this.featureLayerChange} value={this.state.gasserviceFeatureLayer}>
														{this.state.gasserviceFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="gasservice" className="featureFieldName" data-field_type_id="1" name="gaserviceField" onChange={this.fieldChange} value={this.state.gasserviceField1}>
														{this.state.gasserviceFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Start Depth:
							                        <select id="gasservice" className="featureFieldName" data-field_type_id="2" name="gaserviceField" onChange={this.fieldChange} value={this.state.gasserviceField2}>
														{this.state.gasserviceFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Field:
							                        <select id="gasservice" className="featureFieldName" data-field_type_id="3" name="gaserviceField" onChange={this.fieldChange} value={this.state.gasserviceField3}>
														{this.state.gasserviceFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="gasservice" type="checkbox" name="gasserviceShapefile" className="featureSelectedCheckbox" checked={this.state.gasserviceShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.gasserviceFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="gasservice" type="checkbox" checked={this.state.gasserviceAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="3" data-feature_layer_type_id="13" data-feature_type="point">
												<div className="layerHeader">Gas Main Valve</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="gasmainvalve" className="featureServiceName" name="gasmainvalveFeatureService" onChange={this.featureServiceChange} value={this.state.gasmainvalveFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="gasmainvalve" className="featureLayerName" name="gasmainvalveFeatureLayer" onChange={this.featureLayerChange} value={this.state.gasmainvalveFeatureLayer}>
														{this.state.gasmainvalveFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="gasmainvalve" className="featureFieldName" data-field_type_id="1" name="gasmainvalveField" data-field_type_id="1" onChange={this.fieldChange} value={this.state.gasmainvalveField1}>
														{this.state.gasmainvalveFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="gasmainvalve" type="checkbox" name="gasmainvalveShapefile" className="featureSelectedCheckbox" checked={this.state.gasmainvalveShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.gasmainvalveFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="gasmainvalve" type="checkbox" checked={this.state.gasmainvalveAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="3" data-feature_layer_type_id="14" data-feature_type="point">
												<div className="layerHeader">Gas Service Valve</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="gasservicevalve" className="featureServiceName" name="gasservicevalveFeatureService" onChange={this.featureServiceChange} value={this.state.gasservicevalveFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="gasservicevalve" className="featureLayerName" name="gasservicevalveFeatureLayer" onChange={this.featureLayerChange} value={this.state.gasservicevalveFeatureLayer}>
														{this.state.gasservicevalveFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="gasservicevalve" className="featureFieldName" data-field_type_id="1" name="gasservicevalveField" data-field_type_id="1" onChange={this.fieldChange} value={this.state.gasservicevalveField1}>
														{this.state.gasservicevalveFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="gasservicevalve" type="checkbox" name="gasserviceShapefile" className="featureSelectedCheckbox" checked={this.state.gasservicevalveShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.gasservicevalveFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="gasservicevalve" type="checkbox" checked={this.state.gasservicevalveAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
								}
								{this.state.sanitaryUpdate &&
									<div className="featureServiceWrapper">
										<div className="selectionHeader" id="sanitaryDropdown" onClick={this.handleDropdown}>
											SANITARY
						                	<img id="sanitaryDropdown" className="downCarrotShow" src="/images/downcarrotblack.png" />
										</div>
										<div id="layerOptionWrapperGeneral" className="featureServiceDropdownWrapper" id="sanitaryDropdownWrapper">
											<div className="layerOptionWrapper" data-feature_service_type_id="7" data-feature_layer_type_id="25" data-feature_type="line">
												<div className="layerHeader">Sanitary Sewer Main</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="sanitarymain" className="featureServiceName" data-feature_service_type_id="7" name="sanitarymainFeatureService" onChange={this.featureServiceChange} value={this.state.sanitarymainFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="sanitarymain" className="featureLayerName" name="sanitarymainFeatureLayer" onChange={this.featureLayerChange} value={this.state.sanitarymainFeatureLayer}>
														{this.state.sanitarymainFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="sanitarymain" className="featureFieldName" data-field_type_id="1" name="sanitarymainField" onChange={this.fieldChange} value={this.state.sanitarymainField1}>
														{this.state.sanitarymainFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Start Depth:
							                        <select id="sanitarymain" className="featureFieldName" data-field_type_id="2" name="sanitarymainField" onChange={this.fieldChange} value={this.state.sanitarymainField2}>
														{this.state.sanitarymainFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Depth:
							                        <select id="sanitarymain" className="featureFieldName" data-field_type_id="3" name="sanitarymainField" onChange={this.fieldChange} value={this.state.sanitarymainField3}>
														{this.state.sanitarymainFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="sanitarymain" type="checkbox" name="sanitarymainShapefile" className="featureSelectedCheckbox" checked={this.state.sanitarymainShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.sanitarymainFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="sanitarymain" type="checkbox" checked={this.state.sanitarymainAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="7" data-feature_layer_type_id="26" data-feature_type="line">
												<div className="layerHeader">Sanitary Service Lead</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="sanitaryservice" className="featureServiceName" name="sanitaryserviceFeatureService" onChange={this.featureServiceChange} value={this.state.sanitaryserviceFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="sanitaryservice" className="featureLayerName" name="sanitaryserviceFeatureLayer" onChange={this.featureLayerChange} value={this.state.sanitaryserviceFeatureLayer}>
														{this.state.sanitaryserviceFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="sanitaryservice" className="featureFieldName" data-field_type_id="1" name="sanitaryserviceField" onChange={this.fieldChange} value={this.state.sanitaryserviceField1}>
														{this.state.sanitaryserviceFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Start Depth:
							                        <select id="sanitaryservice" className="featureFieldName" data-field_type_id="2" name="sanitaryserviceField" onChange={this.fieldChange} value={this.state.sanitaryserviceField2}>
														{this.state.sanitaryserviceFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Depth:
							                        <select id="sanitaryservice" className="featureFieldName" data-field_type_id="3" name="sanitaryserviceField" onChange={this.fieldChange} value={this.state.sanitaryserviceField3}>
														{this.state.sanitaryserviceFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="sanitaryservice" type="checkbox" name="sanitaryserviceShapefile" className="featureSelectedCheckbox" checked={this.state.sanitaryserviceShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.sanitaryserviceFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="sanitaryservice" type="checkbox" checked={this.state.sanitaryserviceAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="7" data-feature_layer_type_id="27" data-feature_type="point">
												<div className="layerHeader">Sanitary Manhole</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="sanitarymanhole" className="featureServiceName" name="sanitarymanholeFeatureService" onChange={this.featureServiceChange} value={this.state.sanitarymanholeFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="sanitarymanhole" className="featureLayerName" name="sanitarymanholeFeatureLayer" onChange={this.featureLayerChange} value={this.state.sanitarymanholeFeatureLayer}>
														{this.state.sanitarymanholeFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="sanitarymanhole" className="featureFieldName" data-field_type_id="1" name="sanitarymanholeField" onChange={this.fieldChange} value={this.state.sanitarymanholeField1}>
														{this.state.sanitarymanholeFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Depth:
							                        <select id="sanitarymanhole" className="featureFieldName" data-field_type_id="2" name="sanitarymanholeField" onChange={this.fieldChange} value={this.state.sanitarymanholeField2}>
														{this.state.sanitarymanholeFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="sanitarymanhole" type="checkbox" name="sanitarymanholeShapefile" className="featureSelectedCheckbox" checked={this.state.sanitarymanholeShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.sanitarymanholeFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="sanitarymanhole" type="checkbox" checked={this.state.sanitarymanholeAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
								}
								{this.state.stormUpdate &&
									<div className="featureServiceWrapper">
										<div className="selectionHeader" id="stormDropdown" onClick={this.handleDropdown}>
											STORM
						                	<img id="stormDropdown" className="downCarrotShow" src="/images/downcarrotblack.png" />
										</div>
										<div id="layerOptionWrapperGeneral" className="featureServiceDropdownWrapper" id="stormDropdownWrapper">
											<div className="layerOptionWrapper" data-feature_service_type_id="4" data-feature_layer_type_id="15" data-feature_type="line">
												<div className="layerHeader">Storm Sewer Main</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="stormmain" className="featureServiceName" data-feature_service_type_id="4" name="stormmainFeatureService" onChange={this.featureServiceChange} value={this.state.stormmainFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="stormmain" className="featureLayerName" name="stormmainFeatureLayer" onChange={this.featureLayerChange} value={this.state.stormmainFeatureLayer}>
														{this.state.stormmainFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="stormmain" className="featureFieldName" data-field_type_id="1" name="stormmainField" onChange={this.fieldChange} value={this.state.stormmainField1}>
														{this.state.stormmainFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Start Depth:
							                        <select id="stormmain" className="featureFieldName" data-field_type_id="2" name="stormmainField" onChange={this.fieldChange} value={this.state.stormmainField2}>
														{this.state.stormmainFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Depth:
							                        <select id="stormmain" className="featureFieldName" data-field_type_id="3" name="stormmainField" onChange={this.fieldChange} value={this.state.stormmainField3}>
														{this.state.stormmainFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="stormmain" type="checkbox" name="stormmainShapefile" className="featureSelectedCheckbox" checked={this.state.stormmainShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.stormmainFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="stormmain" type="checkbox" checked={this.state.stormmainAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="4" data-feature_layer_type_id="16" data-feature_type="line">
												<div className="layerHeader">Storm Service Lead</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="stormservice" className="featureServiceName" name="stormserviceFeatureService" onChange={this.featureServiceChange} value={this.state.stormserviceFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="stormservice" className="featureLayerName" name="stormserviceFeatureLayer" onChange={this.featureLayerChange} value={this.state.stormserviceFeatureLayer}>
														{this.state.stormserviceFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="stormservice" className="featureFieldName" data-field_type_id="1" name="stormserviceField" onChange={this.fieldChange} value={this.state.stormserviceField1}>
														{this.state.stormserviceFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Start Depth:
							                        <select id="stormservice" className="featureFieldName" data-field_type_id="2" name="stormserviceField" onChange={this.fieldChange} value={this.state.stormserviceField2}>
														{this.state.stormserviceFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Depth:
							                        <select id="stormservice" className="featureFieldName" data-field_type_id="3" name="stormserviceField" onChange={this.fieldChange} value={this.state.stormserviceField3}>
														{this.state.stormserviceFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="stormservice" type="checkbox" name="stormserviceShapefile" className="featureSelectedCheckbox" checked={this.state.stormserviceShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.stormserviceFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="stormservice" type="checkbox" checked={this.state.stormserviceAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="4" data-feature_layer_type_id="17" data-feature_type="point">
												<div className="layerHeader">Storm Catchbasin</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="stormcatchbasin" className="featureServiceName" name="stormcatchbasinFeatureService" onChange={this.featureServiceChange} value={this.state.stormcatchbasinFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="stormcatchbasin" className="featureLayerName" name="stormcatchbasinFeatureLayer" onChange={this.featureLayerChange} value={this.state.stormcatchbasinFeatureLayer}>
														{this.state.stormcatchbasinFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="stormcatchbasin" className="featureFieldName" data-field_type_id="1" name="stormcatchbasinField" onChange={this.fieldChange} value={this.state.stormcatchbasinField1}>
														{this.state.stormcatchbasinFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Depth:
							                        <select id="stormcatchbasin" className="featureFieldName" data-field_type_id="2" name="stormcatchbasinField" onChange={this.fieldChange} value={this.state.stormcatchbasinField2}>
														{this.state.stormcatchbasinFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="stormcatchbasin" type="checkbox" name="stormcatchbasinShapefile" className="featureSelectedCheckbox" checked={this.state.stormcatchbasinShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.stormcatchbasinFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="stormcatchbasin" type="checkbox" checked={this.state.stormcatchbasinAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="4" data-feature_layer_type_id="18" data-feature_type="point">
												<div className="layerHeader">Storm Manhole</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="stormmanhole" className="featureServiceName" name="stormmanholeFeatureService" onChange={this.featureServiceChange} value={this.state.stormmanholeFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="stormmanhole" className="featureLayerName" name="stormmanholeFeatureLayer" onChange={this.featureLayerChange} value={this.state.stormmanholeFeatureLayer}>
														{this.state.stormmanholeFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="stormmanhole" className="featureFieldName" data-field_type_id="1" name="stormmanholeField" onChange={this.fieldChange} value={this.state.stormmanholeField1}>
														{this.state.stormmanholeFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Depth:
							                        <select id="stormmanhole" className="featureFieldName" data-field_type_id="2" name="stormmanholeField" onChange={this.fieldChange} value={this.state.stormmanholeField2}>
														{this.state.stormmanholeFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="stormmanhole" type="checkbox" name="stormmanholeShapefile" className="featureSelectedCheckbox" checked={this.state.stormmanholeShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.stormmanholeFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="stormmanhole" type="checkbox" checked={this.state.stormmanholeAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
								}
								{this.state.fiberUpdate &&
									<div className="featureServiceWrapper">
										<div className="selectionHeader" id="fiberDropdown" onClick={this.handleDropdown}>
											FIBER
						                	<img id="fiberDropdown" className="downCarrotShow" src="/images/downcarrotblack.png" />
										</div>
										<div id="layerOptionWrapperGeneral" className="featureServiceDropdownWrapper" id="fiberDropdownWrapper">
											<div className="layerOptionWrapper" data-feature_service_type_id="5" data-feature_layer_type_id="20" data-feature_type="line">
												<div className="layerHeader">Fiber Primary Overhead</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="fiberprimaryoverhead" className="featureServiceName" data-feature_service_type_id="5" name="fiberprimaryoverheadFeatureService" onChange={this.featureServiceChange} value={this.state.fiberprimaryoverheadFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="fiberprimaryoverhead" className="featureLayerName" name="fiberprimaryoverheadFeatureLayer" onChange={this.featureLayerChange} value={this.state.fiberprimaryoverheadFeatureLayer}>
														{this.state.fiberprimaryoverheadFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Start Height:
							                        <select id="fiberprimaryoverhead" className="featureFieldName" data-field_type_id="2" name="fiberprimaryoverheadField" onChange={this.fieldChange} value={this.state.fiberprimaryoverheadField2}>
														{this.state.fiberprimaryoverheadFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Height:
							                        <select id="fiberprimaryoverhead" className="featureFieldName" data-field_type_id="3" name="fiberprimaryoverheadField" onChange={this.fieldChange} value={this.state.fiberprimaryoverheadField3}>
														{this.state.fiberprimaryoverheadFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="fiberprimaryoverhead" type="checkbox" name="fiberprimaryoverheadShapefile" className="featureSelectedCheckbox" checked={this.state.fiberprimaryoverheadShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.fiberprimaryoverheadFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="fiberprimaryoverhead" type="checkbox" checked={this.state.fiberprimaryoverheadAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="5" data-feature_layer_type_id="19" data-feature_type="line">
												<div className="layerHeader">Fiber Primary Underground</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="fiberprimaryunderground" className="featureServiceName" name="fiberprimaryundergroundFeatureService" onChange={this.featureServiceChange} value={this.state.fiberprimaryundergroundFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="fiberprimaryunderground" className="featureLayerName" name="fiberprimaryundergroundFeatureLayer" onChange={this.featureLayerChange} value={this.state.fiberprimaryundergroundFeatureLayer}>
														{this.state.fiberprimaryundergroundFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Start Depth:
							                        <select id="fiberprimaryunderground" className="featureFieldName" data-field_type_id="2" name="fiberprimaryundergroundField" onChange={this.fieldChange} value={this.state.fiberprimaryundergroundField2}>
														{this.state.fiberprimaryundergroundFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Depth:
							                        <select id="fiberprimaryunderground" className="featureFieldName" data-field_type_id="3" name="fiberprimaryundergroundField" onChange={this.fieldChange} value={this.state.fiberprimaryundergroundField3}>
														{this.state.fiberprimaryundergroundFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="fiberprimaryunderground" type="checkbox" name="fiberprimaryundergroundShapefile" className="featureSelectedCheckbox" checked={this.state.fiberprimaryundergroundShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.fiberprimaryundergroundFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="fiberprimaryunderground" type="checkbox" checked={this.state.fiberprimaryundergroundAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="5" data-feature_layer_type_id="21" data-feature_type="point">
												<div className="layerHeader">Fiber Manhole</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="fibermanhole" className="featureServiceName" name="fibermanholeFeatureService" onChange={this.featureServiceChange} value={this.state.fibermanholeFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="fibermanhole" className="featureLayerName" name="fibermanholeFeatureLayer" onChange={this.featureLayerChange} value={this.state.fibermanholeFeatureLayer}>
														{this.state.fibermanholeFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="fibermanhole" className="featureFieldName" data-field_type_id="1" name="fibermanholeField" onChange={this.fieldChange} value={this.state.fibermanholeField1}>
														{this.state.fibermanholeFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Depth:
							                        <select id="fibermanhole" className="featureFieldName" data-field_type_id="2" name="fibermanholeField" onChange={this.fieldChange} value={this.state.fibermanholeField2}>
														{this.state.fibermanholeFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="fibermanhole" type="checkbox" name="fibermanholeShapefile" className="featureSelectedCheckbox" checked={this.state.fibermanholeShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.fibermanholeFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="fibermanhole" type="checkbox" checked={this.state.fibermanholeAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
								}
								{this.state.telecomUpdate &&
									<div className="featureServiceWrapper">
										<div className="selectionHeader" id="telecomDropdown" onClick={this.handleDropdown}>
											TELECOMMUNICATIONS
						                	<img id="telecomDropdown" className="downCarrotShow" src="/images/downcarrotblack.png" />
										</div>
										<div id="layerOptionWrapperGeneral" className="featureServiceDropdownWrapper" id="telecomDropdownWrapper">
											<div className="layerOptionWrapper" data-feature_service_type_id="6" data-feature_layer_type_id="23" data-feature_type="line">
												<div className="layerHeader">Telecom Overhead</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="telecomoverhead" className="featureServiceName" data-feature_service_type_id="6" name="telecomoverheadFeatureService" onChange={this.featureServiceChange} value={this.state.telecomoverheadFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="telecomoverhead" className="featureLayerName" name="telecomoverheadFeatureLayer" onChange={this.featureLayerChange} value={this.state.telecomoverheadFeatureLayer}>
														{this.state.telecomoverheadFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Start Height:
							                        <select id="telecomoverhead" className="featureFieldName" data-field_type_id="2" name="telecomoverheadField" onChange={this.fieldChange} value={this.state.telecomoverheadField2}>
														{this.state.telecomoverheadFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Height:
							                        <select id="telecomoverhead" className="featureFieldName" data-field_type_id="3" name="telecomoverheadField" onChange={this.fieldChange} value={this.state.telecomoverheadField3}>
														{this.state.telecomoverheadFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="telecomoverhead" type="checkbox" name="telecomoverheadShapefile" className="featureSelectedCheckbox" checked={this.state.telecomoverheadShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.telecomoverheadFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="telecomoverhead" type="checkbox" checked={this.state.telecomoverheadAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="6" data-feature_layer_type_id="22" data-feature_type="line">
												<div className="layerHeader">Telecom Underground</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="telecomunderground" className="featureServiceName" name="telecomundergroundFeatureService" onChange={this.featureServiceChange} value={this.state.telecomundergroundFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="telecomunderground" className="featureLayerName" name="telecomundergroundFeatureLayer" onChange={this.featureLayerChange} value={this.state.telecomundergroundFeatureLayer}>
														{this.state.telecomundergroundFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Start Depth:
							                        <select id="telecomunderground" className="featureFieldName" data-field_type_id="2" name="telecomundergroundField" onChange={this.fieldChange} value={this.state.telecomundergroundField2}>
														{this.state.telecomundergroundFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Depth:
							                        <select id="telecomunderground" className="featureFieldName" data-field_type_id="3" name="telecomundergroundField" onChange={this.fieldChange} value={this.state.telecomundergroundField3}>
														{this.state.telecomundergroundFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="telecomunderground" type="checkbox" name="telecomundergroundShapefile" className="featureSelectedCheckbox" checked={this.state.telecomundergroundShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.telecomundergroundFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="telecomunderground" type="checkbox" checked={this.state.telecomundergroundAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="6" data-feature_layer_type_id="24" data-feature_type="point">
												<div className="layerHeader">Telecom Manhole</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="telecommanhole" className="featureServiceName" name="telecommanholeFeatureService" onChange={this.featureServiceChange} value={this.state.telecommanholeFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="telecommanhole" className="featureLayerName" name="telecommanholeFeatureLayer" onChange={this.featureLayerChange} value={this.state.telecommanholeFeatureLayer}>
														{this.state.telecommanholeFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="telecommanhole" className="featureFieldName" data-field_type_id="1" name="telecommanholeField" onChange={this.fieldChange} value={this.state.telecommanholeField1}>
														{this.state.telecommanholeFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Depth:
							                        <select id="telecommanhole" className="featureFieldName" data-field_type_id="2" name="telecommanholeField" onChange={this.fieldChange} value={this.state.telecommanholeField2}>
														{this.state.telecommanholeFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="telecommanhole" type="checkbox" name="telecommanholeShapefile" className="featureSelectedCheckbox" checked={this.state.telecommanholeShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.telecommanholeFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="telecommanhole" type="checkbox" checked={this.state.telecommanholeAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
								}
								{this.state.steamUpdate &&
									<div className="featureServiceWrapper">
										<div className="selectionHeader" id="steamDropdown" onClick={this.handleDropdown}>
											STEAM
						                	<img id="steamDropdown" className="downCarrotShow" src="/images/downcarrotblack.png" />
										</div>
										<div id="layerOptionWrapperGeneral" className="featureServiceDropdownWrapper" id="steamDropdownWrapper">
											<div className="layerOptionWrapper" data-feature_service_type_id="9" data-feature_layer_type_id="37" data-feature_type="line">
												<div className="layerHeader">Steam Main</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="steammain" className="featureServiceName" data-feature_service_type_id="9" name="steammainFeatureService" onChange={this.featureServiceChange} value={this.state.steammainFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="steammain" className="featureLayerName" name="steammainFeatureLayer" onChange={this.featureLayerChange} value={this.state.steammainFeatureLayer}>
														{this.state.steammainFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="steammain" className="featureFieldName" data-field_type_id="1" name="steammainField" onChange={this.fieldChange} value={this.state.steammainField1}>
														{this.state.steammainFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Start Depth:
							                        <select id="steammain" className="featureFieldName" data-field_type_id="2" name="steammainField" onChange={this.fieldChange} value={this.state.steammainField2}>
														{this.state.steammainFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Depth:
							                        <select id="steammain" className="featureFieldName" data-field_type_id="3" name="steammainField" onChange={this.fieldChange} value={this.state.steammainField3}>
														{this.state.steammainFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="steammain" type="checkbox" name="steammainShapefile" className="featureSelectedCheckbox" checked={this.state.steammainShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.steammainFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="steammain" type="checkbox" checked={this.state.steammainAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="9" data-feature_layer_type_id="44" data-feature_type="line">
												<div className="layerHeader">Steam Service</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="steamservice" className="featureServiceName" name="steamserviceFeatureService" onChange={this.featureServiceChange} value={this.state.steamserviceFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="steamservice" className="featureLayerName" name="steamserviceFeatureLayer" onChange={this.featureLayerChange} value={this.state.steamserviceFeatureLayer}>
														{this.state.steamserviceFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolyline" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
							                        Diameter Field:
							                        <select id="steamservice" className="featureFieldName" data-field_type_id="1" name="steamserviceField" onChange={this.fieldChange} value={this.state.steamserviceField1}>
														{this.state.steamserviceFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        Start Depth:
							                        <select id="steamservice" className="featureFieldName" data-field_type_id="2" name="steamserviceField" onChange={this.fieldChange} value={this.state.steamserviceField2}>
														{this.state.steamserviceFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
							                        End Depth:
							                        <select id="steamservice" className="featureFieldName" data-field_type_id="3" name="steamserviceField" onChange={this.fieldChange} value={this.state.steamserviceField3}>
														{this.state.steamserviceFields.filter((field) => field.type == "" || field.type == "esriFieldTypeDouble" || field.type == "esriFieldTypeInteger" || field.type == "esriFieldTypeSmallInteger").map((field) => <option key={field.name} value={field.name}>{field.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="steamservice" type="checkbox" name="steamserviceShapefile" className="featureSelectedCheckbox" checked={this.state.steamserviceShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.steamserviceFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="steamservice" type="checkbox" checked={this.state.steamserviceAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="9" data-feature_layer_type_id="38" data-feature_type="point">
												<div className="layerHeader">Steam Anchor</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="steamanchor" className="featureServiceName" name="steamanchorFeatureService" onChange={this.featureServiceChange} value={this.state.steamanchorFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="steamanchor" className="featureLayerName" name="steamanchorFeatureLayer" onChange={this.featureLayerChange} value={this.state.steamanchorFeatureLayer}>
														{this.state.steamanchorFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="steamanchor" type="checkbox" name="steamanchorShapefile" className="featureSelectedCheckbox" checked={this.state.steamanchorShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.steamanchorFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="steamanchor" type="checkbox" checked={this.state.steamanchorAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="9" data-feature_layer_type_id="39" data-feature_type="point">
												<div className="layerHeader">Steam Expansion Joint</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="steamexpansionjoint" className="featureServiceName" name="steamexpansionjointFeatureService" onChange={this.featureServiceChange} value={this.state.steamexpansionjointFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="steamexpansionjoint" className="featureLayerName" name="steamexpansionjointFeatureLayer" onChange={this.featureLayerChange} value={this.state.steamexpansionjointFeatureLayer}>
														{this.state.steamexpansionjointFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="steamexpansionjoint" type="checkbox" name="steamexpansionjointShapefile" className="featureSelectedCheckbox" checked={this.state.steamexpansionjointShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.steamexpansionjointFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="steamexpansionjoint" type="checkbox" checked={this.state.steamexpansionjointAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="9" data-feature_layer_type_id="40" data-feature_type="point">
												<div className="layerHeader">Steam Fitting</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="steamfitting" className="featureServiceName" name="steamfittingFeatureService" onChange={this.featureServiceChange} value={this.state.steamfittingFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="steamfitting" className="featureLayerName" name="steamfittingFeatureLayer" onChange={this.featureLayerChange} value={this.state.steamfittingFeatureLayer}>
														{this.state.steamfittingFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="steamfitting" type="checkbox" name="steamfittingShapefile" className="featureSelectedCheckbox" checked={this.state.steamfittingShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.steamfittingFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="steamfitting" type="checkbox" checked={this.state.steamfittingAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="9" data-feature_layer_type_id="41" data-feature_type="point">
												<div className="layerHeader">Steam Control Valve</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="steamcontrolvalve" className="featureServiceName" name="steamcontrolvalveFeatureService" onChange={this.featureServiceChange} value={this.state.steamcontrolvalveFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="steamcontrolvalve" className="featureLayerName" name="steamcontrolvalveFeatureLayer" onChange={this.featureLayerChange} value={this.state.steamcontrolvalveFeatureLayer}>
														{this.state.steamcontrolvalveFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPoint" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="steamcontrolvalve" type="checkbox" name="steamcontrolvalveShapefile" className="featureSelectedCheckbox" checked={this.state.steamcontrolvalveShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.steamcontrolvalveFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="steamcontrolvalve" type="checkbox" checked={this.state.steamcontrolvalveAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
											<div className="layerOptionWrapper" data-feature_service_type_id="9" data-feature_layer_type_id="42" data-feature_type="point">
												<div className="layerHeader">Steam Vault</div>
												<div className="layerSelection">
													Feature Service:
							                        <select id="steamvault" className="featureServiceName" name="steamvaultFeatureService" onChange={this.featureServiceChange} value={this.state.steamvaultFeatureService}>
														{this.state.featureServices.map((featureService, index) => <option key={featureService.name + index} value={featureService.name}>{featureService.name}</option>)}
													</select>
							                        Feature Layer:
							                        <select id="steamvault" className="featureLayerName" name="steamvaultFeatureLayer" onChange={this.featureLayerChange} value={this.state.steamvaultFeatureLayer}>
														{this.state.steamvaultFeatureLayers.filter((featureLayer) => featureLayer.geometryType == "esriGeometryPolygon" || featureLayer.geometryType == "").map((featureLayer) => <option key={featureLayer.name} value={featureLayer.name}>{featureLayer.name}</option>)}
													</select>
													<br />
							                        Allow Shapefile:&nbsp;
							                        <input id="steamvault" type="checkbox" name="steamvaultShapefile" className="featureSelectedCheckbox" checked={this.state.steamvaultShapefile} onChange={this.changeRadio} />
													<div className="selectFields">
														<div className="selectFieldsHeader">
															<b>Select Attributes To Share:</b>
														</div>
														{this.state.steamvaultFields.filter((field) => field.name != "").map((field) =>
															<div className="selectFieldOption" key={field.name}>
																<input id="steamvault" type="checkbox" checked={this.state.steamvaultAttributes.includes(field.name)} className="featureSelectedCheckbox" value={field.name} onChange={this.attributeUpdate} readOnly /> {field.name}
															</div>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
								}
								<br />
								<br />
								<button id="submitMappingSettings" className="submitProjectBtn" onClick={this.handleSubmit} >SAVE CHANGES</button>
							</div>
						</div>
					</div>
				);
			} else {
				return (
					<Route>
						<Redirect to="/projects" />
					</Route>
				);
			}
		}
	}
}

export default AccountMapping;